import { PayInMethodCode } from 'constants/pay-in-method';
export function filterOutEmptyWallet(payInMethods, walletBalance) {
  return payInMethods.filter(_ref => {
    let {
      code
    } = _ref;
    return code !== PayInMethodCode.Wallet || parseFloat(walletBalance.amount) > 0;
  });
}